import { apiRequest } from '../../lib/api.js';

export function renderCustomerPayments() {
    return `
    <section class="page-header" style="background: var(--color-surface-warm);">
      <div class="container">
        <h1 class="page-title">Payment History</h1>
        <p class="page-subtitle">View all your payment transactions</p>
      </div>
    </section>
    <section style="padding: var(--space-10) 0 var(--space-20);">
      <div class="container" style="max-width:900px;">
        <!-- Summary Cards -->
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:var(--space-4);margin-bottom:var(--space-8);">
          <div id="total-paid-card" style="background:var(--color-surface);padding:var(--space-6);border-radius:var(--radius-xl);border:1px solid var(--color-border);text-align:center;">
            <p style="font-size:13px;color:var(--color-text-muted);margin:0;">Total Paid</p>
            <p id="total-paid" style="font-size:24px;font-weight:700;color:var(--color-success);margin:var(--space-2) 0 0;">₹0</p>
          </div>
          <div style="background:var(--color-surface);padding:var(--space-6);border-radius:var(--radius-xl);border:1px solid var(--color-border);text-align:center;">
            <p style="font-size:13px;color:var(--color-text-muted);margin:0;">Pending</p>
            <p id="total-pending" style="font-size:24px;font-weight:700;color:var(--color-warning);margin:var(--space-2) 0 0;">₹0</p>
          </div>
          <div style="background:var(--color-surface);padding:var(--space-6);border-radius:var(--radius-xl);border:1px solid var(--color-border);text-align:center;">
            <p style="font-size:13px;color:var(--color-text-muted);margin:0;">Projects</p>
            <p id="total-projects" style="font-size:24px;font-weight:700;color:var(--color-primary);margin:var(--space-2) 0 0;">0</p>
          </div>
        </div>

        <!-- Payment List -->
        <div id="payments-list" style="background:var(--color-surface);border-radius:var(--radius-xl);border:1px solid var(--color-border);overflow:hidden;">
          <div style="text-align:center;padding:var(--space-8);color:var(--color-text-muted);">Loading payments...</div>
        </div>
      </div>
    </section>
  `;
}

export function initCustomerPayments() {
    async function load() {
        try {
            const data = await apiRequest('/projects');
            const projects = data.data || [];
            const container = document.getElementById('payments-list');

            let totalPaid = 0;
            let totalPending = 0;

            projects.forEach(p => {
                totalPaid += parseFloat(p.paid_amount || 0);
                totalPending += parseFloat(p.total_amount || 0) - parseFloat(p.paid_amount || 0);
            });

            document.getElementById('total-paid').textContent = '₹' + totalPaid.toLocaleString('en-IN');
            document.getElementById('total-pending').textContent = '₹' + Math.max(0, totalPending).toLocaleString('en-IN');
            document.getElementById('total-projects').textContent = projects.length;

            if (!projects.length) {
                container.innerHTML = '<div style="text-align:center;padding:var(--space-12);color:var(--color-text-muted);">No payment history yet</div>';
                return;
            }

            container.innerHTML = projects.map(p => {
                const paid = parseFloat(p.paid_amount || 0);
                const total = parseFloat(p.total_amount || 0);
                const pending = Math.max(0, total - paid);
                const paidPct = total > 0 ? (paid / total * 100).toFixed(0) : 0;

                return `
          <div style="padding:var(--space-5) var(--space-6);border-bottom:1px solid var(--color-border);">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:var(--space-3);">
              <div>
                <h4 style="margin:0;font-size:15px;">${p.title}</h4>
                <p style="margin:2px 0 0;font-size:12px;color:var(--color-text-muted);text-transform:capitalize;">${p.status || 'quote'} · ${p.city || ''}</p>
              </div>
              <div style="text-align:right;">
                <p style="margin:0;font-size:15px;font-weight:700;">₹${total.toLocaleString('en-IN')}</p>
                <p style="margin:2px 0 0;font-size:12px;color:var(--color-success);">${paidPct}% paid</p>
              </div>
            </div>
            <div style="display:flex;gap:var(--space-6);font-size:13px;">
              <div><span style="color:var(--color-text-muted);">Paid:</span> <strong style="color:var(--color-success);">₹${paid.toLocaleString('en-IN')}</strong></div>
              <div><span style="color:var(--color-text-muted);">Pending:</span> <strong style="color:${pending > 0 ? 'var(--color-warning)' : 'var(--color-text)'};">₹${pending.toLocaleString('en-IN')}</strong></div>
            </div>
            <div style="height:4px;background:var(--color-border);border-radius:2px;margin-top:var(--space-3);">
              <div style="height:100%;width:${paidPct}%;background:var(--color-success);border-radius:2px;"></div>
            </div>
          </div>
        `;
            }).join('');
        } catch (e) {
            document.getElementById('payments-list').innerHTML = `
        <div style="text-align:center;padding:var(--space-8);color:var(--color-error);">
          <p>Please log in to view payments.</p>
          <a href="/login" class="btn btn-primary" style="margin-top:var(--space-4);">Login</a>
        </div>
      `;
        }
    }
    load();
}
